export default __webpack_public_path__ + "static/media/17.8328309b.jpg";